<template>
    <div class="bg-color">
        <Navbar />
        <Header :category="'press'" :title="bannerTitle" :breadCrumb="breadCrumb" />
        <DocumentBody :title="bannerTitle" :tagGroup="tagGroup"/>
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
    import Navbar from 'components/DefaultHome/KECC/Common/NavbarStyle'
    import Header from 'components/DefaultHome/KECC/Common/Header'
    import DocumentBody from 'components/DefaultHome/KECC/Press/Document/DocumentBody'
    import FooterTop from 'components/DefaultHome/KECC/Common/FooterTop?v=1.0'
    import FooterBottom from 'components/DefaultHome/KECC/Common/BacktopButton'

    export default {
        name: 'Document',
        metaInfo() {
            return {
                title: this.$t("navbar.menu_2_6"),
            }
        },
        components: {
            Navbar,
            Header,
            DocumentBody,
            FooterTop,
            FooterBottom,
        },
        data() {
            return {
                bannerTitle: this.$t("navbar.menu_2_6"),
                breadCrumb: [{
                    name: this.$t('navbar.menu_2')
                }],
                tagGroup:"檔案下載"
            }
        },
    }
</script>

<style>
    .bg-color {
        background-color: #eff4f5;
    }
</style>